// eslint-disable-next-line no-restricted-imports
import z from 'zod';

export { z };
export default z;
